{
  "dataType": {
    "products": "products",
    "customers": "customers",
    "merchant": "merchants",
    "purchases": "purchases",
    "pricing": "prices",
    "companies": "companies",
    "company_location": "sections",
    "company_contact": "section customers"
  }
}
